export const heroMeta = {
  issue: 'VOL.091',
  date: '09 月 12 日 · 周六',
  title: '看料91',
  titleAccent: '热门 · 爆款',
  subtitle: '实时更新的聚合看板',
  description:
    '看料91热门、爆款内容实时盘点，把高能焦点一网打尽。这里聚合当下热议话题与火料，帮你快速判断最值得关注的看点。',
  updatedText: '刚刚更新',
};

export const heroStats = [
  { label: '今日更新', value: '128', unit: '条' },
  { label: '收录话题', value: '36', unit: '个' },
  { label: '热度峰值', value: '98.6', unit: '' },
];

export const tickerItems = [
  '城市夜行 新一期上线，开播十分钟话题冲上榜首',
  '山城夜市限流，现场直播三小时吸引十万人围观',
  '新生代乐队巡演加场，二线城市门票同步开售',
  '轻量化露营套装走红，搜索热度一周翻倍',
  '早春骑行路线评选开启，五条城市绿道进入候选',
];

export const flashItems = [
  {
    time: '09:12',
    tag: '热议',
    title: '《城市夜行》新一期上线，开播十分钟话题冲上榜首',
    desc: '本期把镜头交给深夜的街巷与摊主，开播即被大量讨论，相关话题在两小时内登上热议首位。',
    heat: '热搜第 1',
  },
  {
    time: '09:48',
    tag: '高能',
    title: '山城夜市限流，摊主直播三小时吸引十万人围观',
    desc: '人气摊位排队长度刷新记录，主办方临时加开两条通道，现场秩序稳定后热度继续攀升。',
    heat: '热度 +42%',
  },
  {
    time: '10:26',
    tag: '焦点',
    title: '新生代乐队巡演加场，二线城市门票同步开售',
    desc: '主办方回应加场需求，新增四站行程，票务页面访问量在开售前就已走高。',
    heat: '焦点榜 2',
  },
  {
    time: '11:05',
    tag: '爆款',
    title: '轻量化露营套装走红，搜索热度一周翻倍',
    desc: '兼顾收纳与重量的装备组合成为讨论重点，多条实测内容被反复转发。',
    heat: '爆款指数 89',
  },
  {
    time: '11:40',
    tag: '热门',
    title: '早春骑行路线评选开启，五条城市绿道进入候选',
    desc: '评选开放当天就收到大量路线推荐，滨水与山林两类路径最受关注。',
    heat: '热门榜 5',
  },
  {
    time: '12:18',
    tag: '火料',
    title: '老牌综艺回归阵容公布，情怀与新鲜感同台',
    desc: '名单兼顾熟面孔与新面孔，节目组表示会保留经典环节并加入全新玩法。',
    heat: '火料第 3',
  },
];

export const hotBoard = [
  {
    rank: 1,
    title: '《城市夜行》新一期上线，深夜街巷成焦点',
    category: '影视综',
    heatValue: 98.6,
    heatText: '98.6',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20night%20street%20food%20stall%20with%20glowing%20sign%20and%20steam%2C%20amber%20tones%2C%20appetizing%20editorial%20photography&width=400&height=400&seq=kl91-rank-01&orientation=squarish',
  },
  {
    rank: 2,
    title: '山城夜市限流现场，摊主直播获十万人围观',
    category: '城市生活',
    heatValue: 95.2,
    heatText: '95.2',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20reading%20corner%20with%20warm%20lamp%20glow%2C%20plants%20and%20books%2C%20soft%20editorial%20photography&width=400&height=400&seq=kl91-rank-02&orientation=squarish',
  },
  {
    rank: 3,
    title: '新生代乐队巡演加场，二线城市门票同步开售',
    category: '现场演出',
    heatValue: 92.8,
    heatText: '92.8',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=athletic%20running%20track%20at%20golden%20sunset%20with%20warm%20light%20streaks%2C%20editorial%20sports%20photography&width=400&height=400&seq=kl91-rank-03&orientation=squarish',
  },
  {
    rank: 4,
    title: '轻量化露营套装走红，搜索热度一周翻倍',
    category: '潮流消费',
    heatValue: 89.4,
    heatText: '89.4',
    trend: 'up',
  },
  {
    rank: 5,
    title: '早春骑行路线评选开启，五条绿道进入候选',
    category: '城市生活',
    heatValue: 86.1,
    heatText: '86.1',
    trend: 'flat',
  },
  {
    rank: 6,
    title: '老牌综艺回归阵容公布，情怀与新鲜感同台',
    category: '影视综',
    heatValue: 83.7,
    heatText: '83.7',
    trend: 'up',
  },
  {
    rank: 7,
    title: '城市漫展门票售罄，主办方宣布增设夜间场',
    category: '现场演出',
    heatValue: 80.3,
    heatText: '80.3',
    trend: 'down',
  },
  {
    rank: 8,
    title: '街角咖啡新店试营业，拿铁配方被反复讨论',
    category: '城市生活',
    heatValue: 76.5,
    heatText: '76.5',
    trend: 'flat',
  },
  {
    rank: 9,
    title: '演员转型导演首作定档，预告片质感获好评',
    category: '影视综',
    heatValue: 73.2,
    heatText: '73.2',
    trend: 'down',
  },
  {
    rank: 10,
    title: '高校电竞赛事开赛，校园解说阵容同步公布',
    category: '现场演出',
    heatValue: 70.8,
    heatText: '70.8',
    trend: 'up',
  },
];

export const hotCategories = [
  { name: '影视综', heat: 96, delta: '+12%' },
  { name: '城市生活', heat: 88, delta: '+9%' },
  { name: '现场演出', heat: 81, delta: '+6%' },
  { name: '潮流消费', heat: 69, delta: '+4%' },
  { name: '科技数码', heat: 54, delta: '+2%' },
];

export const focusCovers = [
  {
    tag: '焦点封面',
    title: '城市夜行：把镜头交给深夜的街巷与摊主',
    desc: '一盏灯、一口锅、一段深夜对话，构成了这一期最值得停留的画面。',
    meta: '影像 · 8 分钟阅读',
    image:
      'https://readdy.ai/api/search-image?query=warm%20cinematic%20evening%20city%20street%20with%20glowing%20lantern%20lights%20and%20lively%20crowds%2C%20amber%20tones%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=kl91-focus-01&orientation=landscape',
  },
  {
    tag: '生活方式',
    title: '轻装出发：周末露营的装备清单',
    desc: '从收纳到重量，实测后留下的八件常备物品。',
    meta: '清单 · 6 分钟阅读',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20warm%20studio%20interior%20with%20soft%20amber%20lamps%20and%20wooden%20textures%2C%20minimalist%20clean%20aesthetic%2C%20magazine%20feature%20photography&width=900&height=700&seq=kl91-focus-02&orientation=landscape',
  },
  {
    tag: '现场演出',
    title: '舞台回暖：灯光亮起的那一刻',
    desc: '巡演加场、音乐节重启，现场的欢呼回来了。',
    meta: '现场 · 5 分钟阅读',
    image:
      'https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20golden%20spotlights%20and%20silhouette%20crowd%2C%20cinematic%20deep%20tones%2C%20editorial%20music%20photography&width=900&height=700&seq=kl91-focus-03&orientation=landscape',
  },
  {
    tag: '旅行',
    title: '春日骑行：沿着城市绿道一路向前',
    desc: '五条候选路线，适合一个下午慢慢骑完。',
    meta: '路线 · 7 分钟阅读',
    image:
      'https://readdy.ai/api/search-image?query=sunset%20mountain%20road%20trip%20with%20crimson%20sky%2C%20warm%20reflections%20on%20the%20road%2C%20editorial%20travel%20photography%2C%20wide%20open%20landscape&width=900&height=700&seq=kl91-focus-04&orientation=landscape',
  },
];

export const topicGroups = [
  {
    name: '影视综',
    desc: '新剧开播 · 综艺回归',
    tags: ['新剧开播', '综艺回归', '电影定档', '导演首作', '经典重映'],
  },
  {
    name: '城市生活',
    desc: '夜市 · 咖啡 · 露营',
    tags: ['夜市烟火', '咖啡新店', '周末露营', '城市绿道', '手作市集'],
  },
  {
    name: '现场演出',
    desc: '巡演 · 音乐节 · 赛事',
    tags: ['巡演加场', '音乐节', '话剧舞台', '漫展夜场', '校园电竞'],
  },
  {
    name: '潮流消费',
    desc: '装备 · 联名 · 新品',
    tags: ['轻量装备', '国潮联名', '复古相机', '智能穿戴', '家居好物'],
  },
];

export const footerLinks = [
  ['站内导航', ['实时快讯', '热度榜单', '焦点封面', '话题聚合']],
  ['内容分类', ['影视综', '城市生活', '现场演出', '潮流消费']],
  ['关于本站', ['站点介绍', '更新说明', '联系方式', '免责声明']],
];